const FIELD_LABELS = { business_name: "Business name", logo_url: "Logo", photos: "Photo gallery" };

function DiffValue({ field, value, testId }) {
  if (field === "logo_url") {
    return value
      ? <img src={value} alt="logo" className="h-16 w-16 object-contain bg-black border border-[#262626]" data-testid={testId} />
      : <span className="text-[#52525B]" data-testid={testId}>No logo</span>;
  }
  if (field === "photos") {
    const list = Array.isArray(value) ? value : [];
    if (list.length === 0) return <span className="text-[#52525B]" data-testid={testId}>No photos</span>;
    return (
      <div className="flex flex-wrap gap-1" data-testid={testId}>
        {list.map((u, i) => <img key={u + i} src={u} alt="" className="h-14 w-14 object-cover border border-[#262626]" />)}
      </div>
    );
  }
  return <span className="text-white break-words" data-testid={testId}>{value ? String(value) : <span className="text-[#52525B]">—</span>}</span>;
}

export function PendingDiff({ listing }) {
  const pending = listing.pending_changes || {};
  return (
    <div className="mt-3 border border-[#FF5722]/30 bg-[#0A0A0A]" data-testid={`admin-pending-diff-${listing.id}`}>
      <div className="grid grid-cols-[140px_1fr_1fr] font-mono text-[10px] tracking-widest uppercase border-b border-[#262626]">
        <div className="p-2 text-[#FF5722]">Pending edit</div>
        <div className="p-2 text-[#9CA3AF] border-l border-[#262626]">Current (live)</div>
        <div className="p-2 text-[#00D4FF] border-l border-[#262626]">Proposed</div>
      </div>
      {Object.entries(pending).map(([field, proposed]) => (
        <div key={field} className="grid grid-cols-[140px_1fr_1fr] font-plex text-sm border-b border-[#262626] last:border-b-0" data-testid={`admin-diff-row-${listing.id}-${field}`}>
          <div className="p-3 font-mono text-xs text-white">{FIELD_LABELS[field] || field}</div>
          <div className="p-3 border-l border-[#262626] opacity-70">
            <DiffValue field={field} value={listing[field]} testId={`admin-diff-current-${listing.id}-${field}`} />
          </div>
          <div className="p-3 border-l border-[#262626] bg-[#00D4FF]/5">
            <DiffValue field={field} value={proposed} testId={`admin-diff-proposed-${listing.id}-${field}`} />
          </div>
        </div>
      ))}
    </div>
  );
}
